/**
 * Global fetch interceptor that detects expired sessions (401 on /api/ routes)
 * and redirects to the home page with a session-expired indicator.
 *
 * Skips overlay/kiosk routes to avoid disrupting live broadcasts.
 */

let sessionExpiredHandled = false

function handleSessionExpired() {
  if (sessionExpiredHandled) return
  sessionExpiredHandled = true

  const path = window.location.pathname.toLowerCase()
  if (path.includes('/overlay') || path.includes('/kiosk')) return

  window.location.href = '/?session=expired'
}

const originalFetch = window.fetch.bind(window)

window.fetch = async function (input, init) {
  const response = await originalFetch(input, init)

  if (response.status === 401) {
    const url = typeof input === 'string' ? input : input?.url || ''
    if (url.startsWith('/api/') && !url.includes('/api/logout') && !url.includes('/api/profile')) {
      handleSessionExpired()
    }
  }

  return response
}
